import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmazing = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.125 10.4997C10.6773 10.4997 11.125 10.052 11.125 9.49973V5.87473C11.125 5.32244 10.6773 4.87473 10.125 4.87473H8.4375V2.51706C8.4375 2.06445 8.1335 1.66827 7.69632 1.55113L7.56879 1.51696C7.1316 1.39982 6.67024 1.59092 6.44394 1.98288L4.77433 4.87473V10.4997H10.125Z",
		fill: "#C4D7FD"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.9375 4.87473C2.38522 4.87473 1.9375 5.32244 1.9375 5.87473V9.49973C1.9375 10.052 2.38522 10.4997 2.9375 10.4997H4.77433V4.87473H2.9375Z",
		fill: "#6C9CFA"
	})]
});
export default SvgAmazing;
